<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <div class="p-grid">
          <div class="p-col-12 p-d-flex p-justify-between">
            <h4>ประวัติวิทยากร</h4>
            <div>
              <Button
                label="สร้างใหม่"
                icon="pi pi-plus"
                class="p-ml-2"
                @click="onNewInstructor"
              ></Button>
              <back-button class="p-ml-2" />
            </div>
          </div>
          <div class="p-col-12">
            <div class="p-grid">
              <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="pi pi-search"></i>
                  </span>
                  <InputText
                    v-model="searchString"
                    placeholder="ระบุคำค้น"
                  ></InputText>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <DataTable
              :paginator="true"
              :rows="10"
              :rowsPerPageOptions="[10, 20, 50]"
              :value="filteredInstructor"
              :scrollable="true"
              scrollHeight="60vh"
              class="p-datatable-sm"
              ref="instructorTable"
              dataKey="id"
            >
              <template #empty>ไม่พบข้อมูล</template>
              <Column
                field="id"
                header="รหัส"
                headerStyle="width: 8rem"
                bodyStyle="width: 8rem"
                :sortable="true"
              >
              </Column>
              <Column field="name" header="ชื่อวิทยากร" :sortable="true">
              </Column>
              <Column field="position" header="ตำแหน่ง" :sortable="true">
              </Column>
              <Column field="address1" header="ที่อยู่1" :sortable="true">
              </Column>
              <Column field="address2" header="ที่อยู่2" :sortable="true">
              </Column>
              <Column field="telNo" header="เบอร์โทร" :sortable="true">
              </Column>
              <Column field="email" header="Email" :sortable="true"> </Column>
              <Column
                field="institute"
                header="สถาบันหรือบริษัทต้นสังกัด"
                :sortable="true"
              >
              </Column>
              <Column headerStyle="width: 7rem;" bodyStyle="width:7rem">
                <template #body="props">
                  <Button
                    class="p-button-rounded p-button-success p-mr-2"
                    icon="pi pi-pencil"
                    @click="onEditInstructor(props.data)"
                  ></Button>
                  <Button
                    class="p-button-rounded p-button-warning"
                    icon="pi pi-trash"
                    @click="onDeleteInstructor(props.data)"
                  ></Button>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    class="p-fluid"
    :header="instructor.id ? 'แก้ไขวิทยากร' : 'เพิ่มวิทยากร'"
  >
    <div class="p-field" v-if="instructor.id">
      <label for="instructorId">รหัส</label>
      <InputText
        maxlength="10"
        id="username"
        v-model.trim="instructor.id"
        required="true"
        :disabled="existInstructorId"
        autofocus
        :class="{ 'p-invalid': submitted && !instructor.id }"
      >
      </InputText>
      <small class="p-error" v-if="submitted && !instructor.id">
        โปรดกรอกรหัส
      </small>
      <small class="p-error" v-if="duplicateInstructorId"> รหัสซ้ำ </small>
    </div>
    <div class="p-field">
      <label for="name">ชื่อวิทยากร</label>
      <InputText
        id="name"
        v-model="instructor.name"
        maxlength="100"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="position">ตำแหน่ง</label>
      <InputText
        id="position"
        v-model="instructor.position"
        maxlength="100"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="address1">ที่อยู่1</label>
      <InputText
        id="address1"
        v-model="instructor.address1"
        maxlength="100"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="address2">ที่อยู่2</label>
      <InputText
        id="address2"
        v-model="instructor.address2"
        maxlength="100"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="telNo">เบอร์โทร</label>
      <InputText
        id="telNo"
        v-model="instructor.telNo"
        maxlength="100"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="email">Email</label>
      <InputText
        id="email"
        v-model="instructor.email"
        maxlength="100"
      ></InputText>
    </div>
    <div class="p-field">
      <label for="institute">สถาบันหรือบริษัทต้นสังกัด</label>
      <InputText
        id="institute"
        v-model="instructor.institute"
        maxlength="100"
      ></InputText>
    </div>
    <template #footer>
      <Button
        icon="pi pi-check"
        label="ยืนยัน"
        id="save"
        class="p-button-success"
        @click="onSaveInstructor"
      ></Button>
      <Button
        icon="pi pi-times"
        label="ยกเลิก"
        id="cancel"
        class="p-button-danger p-ml-2"
        @click="onHideDialog"
      ></Button>
    </template>
  </Dialog>
  <Dialog
    v-model:visible="popupDeleteDialog"
    :style="{ width: '450px' }"
    header="Confirm"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="instructor"
        >Are you sure you want to delete <b>{{ instructor.id }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="popupDeleteDialog = false"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        class="p-button-text"
        @click="handleDeleteInstructor"
      />
    </template>
  </Dialog>
</template>

<script lang="ts">
import { ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { clone } from "ramda";
import { Instructor, UpsertInstructorRequest } from "@/types";
import Fuse from "fuse.js";
import BackButton from "@/components/BackButton.vue";

export default {
  name: "Instructor",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading } = usePlugin();

    const instructorTable = ref(null);
    const instructors = ref<Instructor[]>([]);
    const instructor = ref<Instructor>({} as Instructor);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const existInstructorId = ref(false);
    const duplicateInstructorId = ref(false);

    const filteredInstructor = computed(() => {
      if (!searchString.value) return instructors.value;
      const fuse = new Fuse(instructors.value, {
        keys: ["instructorId", "name"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadInstructors = async () => {
      setLoading(true);
      try {
        const result = await axios.post<Instructor[]>(
          "api/v1/services/instructor/get"
        );
        instructors.value = result.data;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewInstructor = () => {
      instructor.value = {} as Instructor;
      showDialog.value = true;
      submitted.value = false;
      existInstructorId.value = false;
    };

    const onSaveInstructor = async () => {
      submitted.value = true;

      setLoading(true);
      try {
        const result = await axios.post("api/v1/services/instructor/upsert", {
          instructors: [instructor.value],
        } as UpsertInstructorRequest);
        await loadInstructors();
        success("บันทึกข้อมูลสำเร็จแล้ว");
        showDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
      duplicateInstructorId.value = false;
    };

    const onEditInstructor = (source: Instructor) => {
      instructor.value = clone(source);
      showDialog.value = true;
      existInstructorId.value = true;
    };

    const onDeleteInstructor = (source: Instructor) => {
      instructor.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteInstructor = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/instructor/delete", {
          data: {
            instructors: [instructor.value],
          } as UpsertInstructorRequest,
        });
        await loadInstructors();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      await loadInstructors();
    });
    return {
      instructorTable,
      instructor,
      instructors,
      filteredInstructor,
      showDialog,
      submitted,
      existInstructorId,
      duplicateInstructorId,
      popupDeleteDialog,
      searchString,
      onNewInstructor,
      onEditInstructor,
      onDeleteInstructor,
      onSaveInstructor,
      handleDeleteInstructor,
      onHideDialog,
    };
  },
};
</script>
